import type { ItemsGroup, SchemaItem, Table } from "@data-root/types";
import { useMemo } from "react";

export const useTabs = (
  table: Table,
  itemGroups?: ItemsGroup[]
): { tabIds: string[]; tabNames: string[]; tabItems: SchemaItem[][] } => {
  const itemsMap = useMemo<Record<string, SchemaItem>>(
    () => Object.fromEntries(table.items.map((item) => [item.id, item])),
    [table]
  );

  const [tabIds, tabNames, tabItems] = useMemo<[string[], string[], SchemaItem[][]]>(() => {
    if (itemGroups === undefined) return [[table.id], [table.name], [table.items]];

    const tabIds = itemGroups.map((group) => group.id);
    const tabNames = itemGroups.map((group) => group.name);
    const tabItems = itemGroups.map((group) =>
      group.items.map((id) => {
        if (!(id in itemsMap)) throw new Error(`Item ${id} not found in table ${table.name}`);
        return itemsMap[id];
      })
    );

    return [tabIds, tabNames, tabItems];
  }, [table, itemsMap, itemGroups]);

  return { tabIds, tabNames, tabItems };
};
